// The four parent sections as one Tabs navigator (FR-005, FR-006; plan "Chrome"). Mobile chrome
// shows the bottom tab bar; desktop chrome shows none (the header has the links). One navigator for
// both, so crossing the 1024 px breakpoint never remounts the screens.
import { Tabs } from "expo-router";

import { MobileTabBar } from "@/shell/chrome/MobileTabBar";
import { parentSections } from "@/shell/chrome/sections";
import { useChromeKind } from "@/shell/chrome/useChromeKind";
import { useTheme } from "@/theme/useTheme";

export default function ParentTabsLayout() {
  const chrome = useChromeKind();
  const theme = useTheme();
  return (
    <Tabs
      // Navigation's own scene colour is light grey in both themes; screens sit on the token background.
      screenOptions={{
        headerShown: false,
        sceneStyle: { backgroundColor: theme.color.background },
      }}
      tabBar={(props) =>
        chrome === "mobile" ? <MobileTabBar {...props} /> : null
      }
    >
      {parentSections.map((s) => (
        <Tabs.Screen key={s.name} name={s.name} options={{ title: s.label }} />
      ))}
    </Tabs>
  );
}

// A screen that throws shows the themed fallback (FR-041; US6-2).
export { ErrorFallback as ErrorBoundary } from "@/shell/ErrorFallback";
